import React from 'react';
const cacheBustVersion = 2;
export const Svg = ({ className, title, name }) => {
    const href = `/assets/images/intohimonyt.svg?version=${cacheBustVersion}#${name}`;
    return (React.createElement("svg", { className: className },
        title && React.createElement("title", null, title),
        React.createElement("use", { href: href, xlinkHref: href })));
};
